<div class="p-4 w-90 main-drawer-content-container">
    <div class="content-scroll-area scrollbar-hide">
      <ng-container *ngIf="drawerContents?.length ?? 0 > 0; else noContent">
        <div *ngFor="let cell of drawerContents">
          <div
            class="contentsContainer flex flex-col p-2"
            [ngClass]="{ 'border-container': cell.showBorder !== false }"
          >
            <strong
              *ngIf="cell?.cellTitle"
              [ngStyle]="{
                'font-family': cell.titleFontFamily || 'inherit',
                'font-size': cell.titleFontSize || 'inherit',
                'color': cell.titleFontColor || 'inherit',
                'font-weight': cell.titleFontWeight || 'inherit',
                'line-height': cell.titleLineHeight || 'inherit',
                'border-bottom': cell.showBottomBorder
                  ? (cell.bottomBorderWidth || '1px') + ' ' + (cell.bottomBorderStyle || 'solid') + ' ' + (cell.bottomBorderColor || '#ccc')
                  : 'none',
                'padding-bottom': cell.showBottomBorder ? '8px' : '0',
                'margin-bottom': cell.showBottomBorder ? '8px' : '0',
                'display': 'block'
              }"
            >{{ cell.cellTitle }}</strong>
            <!-- Only show data if hideData is false -->
            <ng-container *ngIf="!cell.hideData">
              <ng-container *ngIf="cell?.cellData?.length ?? 0 > 0; else noContent">
                <!-- Bubble display style -->
                <div *ngIf="cell.displayStyle === 'bubble'" class="flex flex-col"
                     [ngStyle]="{ 'gap': cell.rowGap || '0.5rem' }">
                  <div *ngFor="let data of cell.cellData ?? []; let i = index"
                       class="flex flex-row items-center gap-2 w-fit">
                    <mat-icon
                      *ngIf="cell.cellIcons?.[i]"
                      class="text-sm"
                      [ngStyle]="{
                        'color': cell.cellIconColors?.[i] || 'inherit',
                        'font-size': '20px',
                        'width': '20px',
                        'height': '20px'
                      }"
                    >{{ cell.cellIcons![i] }}</mat-icon>
                    <span
                      class="px-2 py-0.5 rounded-full border border-gray-300 inline-block"
                      [ngStyle]="{
                        'font-size': cell.dataFontSize || '14px',
                        'color': cell.dataFontColor || 'inherit',
                        'font-weight': cell.dataFontWeights?.[i] || cell.dataFontWeight || 'inherit',
                        'line-height': '1',
                        'background-color': cell.bubbleBackgroundColor || '#FAFBFF'
                      }"
                    >{{ data }}</span>
                  </div>
                </div>
                <!-- Default display style -->
                <div *ngIf="cell.displayStyle !== 'bubble'" class="flex flex-col">
                  <div *ngFor="let data of cell.cellData ?? []; let i = index" class="flex flex-row items-center gap-2"
                       [ngStyle]="{
                         'border-bottom': cell.dataBottomBorders?.[i] ? '1px solid #d1d5db' : 'none',
                         'padding-bottom': cell.dataBottomBorders?.[i] ? (cell.dataBottomBorderPadding || '8px') : '0',
                         'margin-bottom': cell.dataBottomBorders?.[i] ? '8px' : '0',
                         'font-size': cell.dataFontSize || 'inherit',
                         'font-family': cell.dataFontFamily || 'inherit',
                         'color': cell.dataFontColor || 'inherit',
                         'font-weight': cell.dataFontWeights?.[i] || cell.dataFontWeight || 'inherit',
                         'line-height': cell.dataLineHeight || '36px'
                       }">
                    <mat-icon
                      *ngIf="cell.cellIcons?.[i]"
                      [ngStyle]="{
                        'color': cell.cellIconColors?.[i] || 'inherit'
                      }"
                    >{{ cell.cellIcons![i] }}</mat-icon>
                    <span
                      [ngStyle]="{
                        'font-size': cell.dataFontSize || 'inherit',
                        'color': cell.dataFontColor || 'inherit',
                        'font-weight': cell.dataFontWeight || 'inherit',
                        'line-height': cell.dataLineHeight || 'inherit',
                        'padding-top': cell.dataPaddingY || '0.5rem',
                        'padding-bottom': cell.dataPaddingY || '0.5rem'
                      }"
                    >{{ data }}</span>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-template #noContent>
        <div class="flex flex-col">
          <span>{{ noContentMessage }}</span>
        </div>
      </ng-template>
    </div>
    <div class="drawer-buttons flex flex-row content-center" [ngClass]="disableDelete === false ? 'justify-between' : 'justify-end'">
      <button *ngIf="disableDelete === false" mat-raised-button color="warn" (click)="delete()">
        {{ deleteLabel }}
      </button>
      <button *ngIf="disableEdit === false" mat-raised-button color="primary" (click)="edit()">{{ editLabel }}</button>
    </div>
</div>
